import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Card, Button, Form, Spinner, Container, Badge } from "react-bootstrap";
import { api } from "../../services/api";
import Swal from "sweetalert2";

export default function ConfirmarGozoMobile() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");

    const [loading, setLoading] = useState(true);
    const [periodosLista, setPeriodosLista] = useState([]);
    const [dadosGerais, setDadosGerais] = useState(null);
    const [senha, setSenha] = useState("");
    const [processando, setProcessando] = useState(false);
    const [concluido, setConcluido] = useState(false);

    useEffect(() => {
        if (token) {
            api.get(`/rh/ferias/gozo/detalhes-token/${token}`)
                .then(res => {
                    const data = Array.isArray(res.data) ? res.data : [res.data];
                    if (data.length > 0) {
                        setPeriodosLista(data);

                        // Ordenar de más antiguo a más recente por fecha de inicio
                        const emOrdem = [...data].sort((a, b) => {
                            const dtA = a.DATA_INICIO || a.data_inicio;
                            const dtB = b.DATA_INICIO || b.data_inicio;
                            return new Date(dtA.split('/').reverse().join('-')) - new Date(dtB.split('/').reverse().join('-'));
                        });

                        const primeiro = emOrdem[0];
                        const ultimo = emOrdem[emOrdem.length - 1];
                        const totalDias = data.reduce((acc, item) => acc + Number(item.DIAS_GOZADOS || item.dias_gozados || 0), 0);

                        setDadosGerais({
                            nome: primeiro.NOME || primeiro.nome,
                            matricula: primeiro.MATRICULA || primeiro.matricula,
                            dataInicioGeral: primeiro.DATA_INICIO || primeiro.data_inicio,
                            dataFimGeral: ultimo.DATA_FIM || ultimo.data_fim,
                            totalDias: totalDias
                        });
                    }
                })
                .catch(err => {
                    console.error("Erro ao buscar token:", err);
                    Swal.fire("Erro", "Link inválido ou expirado.", "error");
                })
                .finally(() => setLoading(false));
        } else {
            setLoading(false);
            Swal.fire("Atenção", "Token de confirmação ausente na URL.", "warning");
        }
    }, [token]);

    const handleAssinarFerias = async (e) => {
        e.preventDefault();
        if (!dadosGerais?.matricula) {
            Swal.fire("Erro", "Dados da solicitação não encontrados.", "error");
            return;
        }

        setProcessando(true);
        try {
            // Formata a matrícula para 6 dígitos com zeros à esquerda (ex: "26610" -> "026610")
            const matriculaFormatada = String(dadosGerais.matricula).padStart(6, '0');

            const resAuth = await api.post("/usuario/consultausuario/web", {
                usuario: matriculaFormatada,
                senha: senha,
                versao: "1.2"
            });

            if (resAuth.data?.SUCESSO !== "S") {
                Swal.fire("Senha Incorreta", "A senha digitada está incorreta.", "error");
                setProcessando(false);
                return;
            }

            // Se a senha estiver correta, confirma o gozo passando o token
            await api.post("/rh/ferias/gozo/confirmar", { token });

            setConcluido(true);
            Swal.fire("Férias Confirmadas!", "Sua assinatura digital foi registrada com sucesso.", "success");

        } catch (err) {
            const msg = err.response?.data?.erro || "Erro ao processar assinatura.";
            Swal.fire("Erro", msg, "error");
        } finally {
            setProcessando(false);
        }
    };

    if (loading) {
        return (
            <Container className="text-center pt-5">
                <Spinner animation="border" style={{ color: '#8b0000', width: '3rem', height: '3rem' }} />
                <div className="mt-3 fw-bold text-dark">Carregando detalhes das férias...</div>
            </Container>
        );
    }

    if (concluido) {
        return (
            <Container className="pt-5 px-3" style={{ maxWidth: '480px' }}>
                <Card className="text-center p-4 shadow-sm border-0 rounded-3 bg-white">
                    <div className="display-1 text-success mb-2">
                        <i className="fa-solid fa-circle-check"></i>
                    </div>
                    <h5 className="fw-bold text-dark mb-2">Assinatura Concluída!</h5>
                    <p className="text-muted small mb-0">
                        O lançamento das suas férias foi confirmado e registrado com sucesso no sistema.
                    </p>
                </Card>
            </Container>
        );
    }

    return (
        <Container className="pt-4 px-3 mb-5" style={{ maxWidth: "480px" }}>
            <Card className="shadow-sm border-0 rounded-3 overflow-hidden bg-white">
                <div
                    className="p-3 text-white text-center"
                    style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 100%)' }}
                >
                    <h5 className="fw-bold mb-0">
                        <i className="fa-solid fa-umbrella-beach me-2"></i>Confirmação de Férias
                    </h5>
                    <span className="small opacity-75">Assinatura Digital de Gozo</span>
                </div>

                <Card.Body className="p-3">
                    {/* Encabezado con datos del colaborador */}
                    <div className="bg-light p-3 rounded-3 border mb-3 small">
                        <div className="mb-1 text-muted">
                            Colaborador: <strong className="text-dark">{dadosGerais?.nome}</strong>
                        </div>
                        <div className="text-muted">
                            Matrícula: <strong className="text-dark">{dadosGerais?.matricula}</strong>
                        </div>
                    </div>

                    {/* Desglose de Períodos Aquisitivos */}
                    <div className="mb-3">
                        <h6 className="fw-bold text-dark mb-2 small">
                            <i className="fa-solid fa-calendar-days me-1 text-danger"></i>Períodos Aquisitivos:
                        </h6>
                        {periodosLista.map((item, index) => {
                            const pInicio = item.PERIODO_INICIO || item.periodo_inicio;
                            const pFim = item.PERIODO_FIM || item.periodo_fim;
                            const dias = item.DIAS_GOZADOS || item.dias_gozados;
                            const dInicio = item.DATA_INICIO || item.data_inicio;
                            const dFim = item.DATA_FIM || item.data_fim;

                            return (
                                <div key={index} className="p-2 mb-2 bg-light rounded-2 border border-secondary border-opacity-25 small">
                                    <div className="d-flex justify-content-between align-items-center mb-1">
                                        <span className="fw-bold text-dark">
                                            Período: {pInicio} a {pFim}
                                        </span>
                                        <Badge bg="danger">{dias} {dias > 1 ? 'dias' : 'dia'}</Badge>
                                    </div>
                                    <div className="text-muted" style={{ fontSize: '0.8rem' }}>
                                        Gozo: <strong>{dInicio} até {dFim}</strong>
                                    </div>
                                </div>
                            );
                        })}
                    </div>

                    {/* Resumen Total del Período de Goce */}
                    <div
                        className="p-3 mb-3 rounded-3 text-white d-flex justify-content-between align-items-center shadow-sm"
                        style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 100%)' }}
                    >
                        <div>
                            <span className="d-block small text-white-50 fw-semibold">
                                Período Total de Gozo
                            </span>
                            <span className="fw-bold fs-6 d-block text-white">
                                {dadosGerais?.dataInicioGeral} até {dadosGerais?.dataFimGeral}
                            </span>
                        </div>
                        <Badge bg="light" text="dark" className="px-3 py-2 fs-6 fw-bold shadow-sm">
                            {dadosGerais?.totalDias} dias
                        </Badge>
                    </div>

                    {/* Formulario de Firma */}
                    <Form onSubmit={handleAssinarFerias}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small fw-bold text-dark">
                                <i className="fa-solid fa-lock me-1 text-danger"></i>Digite sua Senha para Assinar
                            </Form.Label>
                            <Form.Control
                                type="password"
                                required
                                placeholder="Sua senha de acesso"
                                value={senha}
                                onChange={(e) => setSenha(e.target.value)}
                                className="rounded-2"
                            />
                        </Form.Group>

                        <Button
                            variant="danger"
                            type="submit"
                            className="w-100 fw-bold btn-arbor-primary py-2 rounded-2"
                            disabled={processando}
                        >
                            {processando ? (
                                <Spinner animation="border" size="sm" />
                            ) : (
                                <>
                                    <i className="fa-solid fa-pen-nib me-2"></i>Confirmar e Assinar Férias
                                </>
                            )}
                        </Button>
                    </Form>
                </Card.Body>
            </Card>
        </Container>
    );
}